module.exports = __webpack_public_path__ + "60fbc221d84de9fb44f0d70882a393fc.svg";